import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { AsyncButton } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { Box, Button, TextField } from '@mui/material';
import { constVoid } from 'fp-ts/function';
import { createContext, useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSaveComment from './use-save-comment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EditField = function EditField(_ref) {
  var editInputRef = _ref.editInputRef,
      defaultValue = _ref.defaultValue;

  var _useEditComment = useEditComment(),
      saveEditStatus = _useEditComment.saveEditStatus,
      editError = _useEditComment.editError,
      save = _useEditComment.save,
      setEditText = _useEditComment.setEditText;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(TextField, {
    sx: {
      flexGrow: 3,
      my: 1,
      width: 1
    },
    error: !!editError,
    helperText: editError !== null && editError !== void 0 ? editError : undefined,
    onChange: function onChange(event) {
      return setEditText(event.target.value);
    },
    onKeyUp: function onKeyUp(event) {
      return event.key === 'Enter' && save();
    },
    inputRef: editInputRef,
    size: "small",
    label: t('Edit reply'),
    disabled: saveEditStatus === 'saving',
    defaultValue: defaultValue,
    "data-element": "TextField",
    "data-component": "EditField",
    "data-source-file": "edit-comment.tsx"
  });
};
export var SaveEditButton = function SaveEditButton() {
  var _useEditComment2 = useEditComment(),
      saveEditStatus = _useEditComment2.saveEditStatus,
      save = _useEditComment2.save,
      stopEditing = _useEditComment2.stopEditing;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsxs(Box, {
    "data-element": "Box",
    "data-component": "SaveEditButton",
    "data-source-file": "edit-comment.tsx",
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: stopEditing,
      "data-element": "Button",
      "data-component": "SaveEditButton",
      "data-source-file": "edit-comment.tsx",
      children: t('Cancel')
    }), /*#__PURE__*/_jsx(AsyncButton, {
      status: saveEditStatus,
      onClick: save,
      text: ['Saving...', 'Save', 'Save', 'Save'],
      "data-element": "AsyncButton",
      "data-source-file": "edit-comment.tsx"
    })]
  });
};
var EditCommentContext = /*#__PURE__*/createContext({
  isEditing: false,
  startEditing: constVoid,
  editError: '',
  stopEditing: constVoid,
  setEditText: constVoid,
  save: constVoid,
  saveEditStatus: 'default'
});
export var useEditComment = function useEditComment() {
  return useContext(EditCommentContext);
};
export var EditCommentProvider = function EditCommentProvider(_ref2) {
  var id = _ref2.id,
      value = _ref2.value,
      children = _ref2.children;

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isEditing = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      on = _useToggle2$.on,
      off = _useToggle2$.off;

  var _useState = useState(value),
      editText = _useState[0],
      setEditText = _useState[1];

  var _useState2 = useState(''),
      editError = _useState2[0],
      setError = _useState2[1];

  var stopEditing = useCallback(function () {
    off();
    setError('');
    setEditText(value);
  }, [off, setError, setEditText, value]);

  var _useSaveComment = useSaveComment({
    id: id,
    onEditSaved: stopEditing
  }),
      saveEditStatus = _useSaveComment.saveEditStatus,
      saveEdit = _useSaveComment.saveEdit;

  var save = useCallback(function () {
    return saveEdit(editText, function () {
      return setError('Reply cannot be empty');
    });
  }, [saveEdit, editText, setError]);
  var startEditing = on;
  return /*#__PURE__*/_jsx(EditCommentContext.Provider, {
    value: {
      isEditing: isEditing,
      startEditing: startEditing,
      editError: editError,
      stopEditing: stopEditing,
      setEditText: setEditText,
      saveEditStatus: saveEditStatus,
      save: save
    },
    "data-element": "unknown",
    "data-component": "EditCommentProvider",
    "data-source-file": "edit-comment.tsx",
    children: children({
      startEditing: startEditing,
      isEditing: isEditing
    })
  });
};